import React from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
} from '@mui/material';
import { styled, Theme } from '@mui/material/styles';
// eslint-disable-next-line import/no-cycle
import { ColumnObject } from './ZerpaTable';

const StyledTableSortLabel = styled(TableSortLabel)(({ theme }: { theme: Theme }) => `
  color: ${theme.palette.primary.contrastText};
  .Mui-active {
    color: ${theme.palette.primary.contrastText};
    text-decoration: underline;
  };
  .MuiTableSortLabel-icon {
    fill: ${theme.palette.primary.contrastText};
  };
`);

export interface ZerpaTableHeaderProps {
  columns: ColumnObject[];
  orderBy?: string;
  order?: false | 'desc' | 'asc' | undefined;
  onColumnClick?: (arg1: ColumnObject) => void;
  color?: 'green';
}

const ZerpaTableHeader: React.FC<ZerpaTableHeaderProps> = (props: ZerpaTableHeaderProps) => {
  const {
    columns,
    orderBy,
    onColumnClick = undefined,
    order = 'desc',
    color,
  } = props;
  return (
    <TableHead
      sx={color ? { backgroundColor: 'tertiary.main' } : { backgroundColor: 'primary.main' }}
    >
      <TableRow>
        {columns.map((column: ColumnObject) => {
          const { text, keyName, sortable = false } = column;
          if (sortable) {
            const activeColumn = orderBy === keyName;
            const sortDirection = activeColumn ? order : false;
            return (
              <TableCell
                key={keyName}
                sortDirection={sortDirection}
                sx={{ color: 'primary.contrastText' }}
              >
                <StyledTableSortLabel
                  active={activeColumn}
                  direction={sortDirection || undefined}
                  onClick={(): void => {
                    if (onColumnClick) {
                      onColumnClick(column);
                    }
                  }}
                >
                  {text}
                </StyledTableSortLabel>
              </TableCell>
            );
          }

          return (<TableCell key={keyName} sx={{ color: 'primary.contrastText' }}>{text}</TableCell>);
        })}
      </TableRow>
    </TableHead>
  );
};

export default ZerpaTableHeader;
